import { render, staticRenderFns } from "./siteAdminGroupForm.vue?vue&type=template&id=00c7a68c&scoped=true&"
import script from "./siteAdminGroupForm.vue?vue&type=script&lang=babel&"
export * from "./siteAdminGroupForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c7a68c",
  null
  
)

export default component.exports